// Dense identity sheet (Conifer .folio-dl): mono CAPS keys (10px .14em faint), left-aligned mono values.
//   <Sheet rows={[{ k: "sha-256", v: <Hash value={sha} />, copy: { value: sha, label: "SHA-256" } }, { k: "size", v: "955 KiB" }]} keyCol? className? />
//   copy → dd.cp with a trailing <CopyButton>; a null / undefined / "" value renders a faint "—"; keyCol overrides the key column width
//   stacks dt over dd under 480px (CSS)
import { Fragment, type ReactNode } from "react";
import { CopyButton } from "./CopyButton";
import { cx } from "./cx";

export type SheetRow = { k: ReactNode; v?: ReactNode; copy?: { value: string; label: string }; key?: string };

export function Sheet({ rows, keyCol, className }: { rows: readonly SheetRow[]; keyCol?: string; className?: string }) {
  return (
    <dl className={cx("sheet content-start", className)} style={keyCol ? { gridTemplateColumns: `${keyCol} minmax(0, 1fr)` } : undefined}>
      {rows.map((r, i) => {
        const missing = r.v === undefined || r.v === null || r.v === "" || r.v === false;
        return (
          <Fragment key={r.key ?? i}>
            <dt>{r.k}</dt>
            {missing ? (
              <dd className="faint">—</dd>
            ) : r.copy ? (
              <dd className="cp">
                <span className="grow">{r.v}</span>
                <CopyButton value={r.copy.value} label={r.copy.label} />
              </dd>
            ) : (
              <dd>{r.v}</dd>
            )}
          </Fragment>
        );
      })}
    </dl>
  );
}
